'use client'

import { useActionState } from 'react'
import Link from 'next/link'
import { loginAction } from './actions'

export default function LoginForm({ registered = false }: { registered?: boolean }) {
  const [state, formAction, pending] = useActionState(loginAction, { error: '' })

  return (
    <>
      {registered && (
        <p className="text-sm text-lime-dark bg-lime/10 border border-lime/20 rounded-lg px-3 py-2 mb-4">
          ¡Cuenta creada! Ya puedes iniciar sesión.
        </p>
      )}
      <form action={formAction} className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">Correo</label>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent"
            placeholder="tu@correo.com"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1.5">Contraseña</label>
          <input
            type="password"
            name="password"
            required
            autoComplete="current-password"
            className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent"
            placeholder="••••••••"
          />
        </div>

        {state.error && (
          <p className="text-xs text-red-500 bg-red-50 px-3 py-2 rounded-lg" aria-live="polite">
            {state.error}
          </p>
        )}

        <button
          type="submit"
          disabled={pending}
          className="w-full bg-navy text-white py-2.5 rounded-lg font-medium text-sm hover:bg-navy-dark transition-colors disabled:opacity-60"
        >
          {pending ? 'Entrando...' : 'Entrar'}
        </button>

        <p className="text-center text-xs text-gray-400 pt-1">
          ¿No tienes cuenta?{' '}
          <Link href="/signup" className="text-navy font-medium hover:underline">
            Regístrate
          </Link>
        </p>
      </form>
    </>
  )
}
